module.exports = require("randombytes");;